module.exports = __webpack_public_path__ + "img/t5.a80cec52.png";